"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.checkIsOpinionatedUrl = exports.VCRLink = void 0;
var _reactRouter = require("@tanstack/react-router");
var _config = require("../../_nextgen/packages/config");
var _Overlay = require("../../modules/Overlay");
var _getNodeText2 = require("../../utilities/getNodeText");
var _analytics = _interopRequireWildcard(require("../analytics"));
var Styled = _interopRequireWildcard(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
// Temp solution
const VCRLink = function (props) {
  const {
    href,
    ...rest
  } = props;
  const route = href.replaceAll("{{", "$").replaceAll("}}", "");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouter.Link, {
    to: route,
    search: function (search) {
      return search;
    },
    ...rest,
    "data-testid": "VCRLink"
  });
};
exports.VCRLink = VCRLink;
const getRootDomain = function (url) {
  if (typeof url !== "string") {
    return url;
  }
  const parts = url === null || url === void 0 ? void 0 : url.split(/[./]+/);
  if (parts.length < 2) {
    return url;
  }
  return `${parts.at(-2)}.${parts.at(-1)}`;
};
const checkIsOpinionatedUrl = function (href) {
  var _href$startsWith, _URL, _window, _window$location, _window2, _window2$location;
  if (!(href !== null && href !== void 0 && (_href$startsWith = href.startsWith) !== null && _href$startsWith !== void 0 && _href$startsWith.call(href, "http"))) return false;
  const outbound = (_URL = new URL(href, (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin)) === null || _URL === void 0 ? void 0 : _URL.hostname;
  const current = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.hostname;
  return getRootDomain(outbound) !== getRootDomain(current);
};
exports.checkIsOpinionatedUrl = checkIsOpinionatedUrl;
const Link = function (_ref) {
  let {
    text,
    children,
    href,
    onClick,
    index = 0,
    rel,
    isExternal: isExternalProp,
    isexternal = undefined,
    disableRouter,
    overrideAnalyticsText = "",
    additionalAnalytics = {},
    ...props
  } = _ref;
  const [show] = (0, _Overlay.useOverlay)({
    id: "third-party-interstitial"
  });
  const _isExternal = isExternalProp !== null && isExternalProp !== void 0 ? isExternalProp : isexternal;
  const isExternal = typeof _isExternal === "undefined" ? undefined : JSON.parse(_isExternal);
  const router = (0, _reactRouter.useRouter)();
  const renderedText = text || children;
  const analyticsText = function () {
    var _getNodeText;
    if (overrideAnalyticsText) {
      return overrideAnalyticsText;
    }
    return (_getNodeText = (0, _getNodeText2.getNodeText)(renderedText)) !== null && _getNodeText !== void 0 && _getNodeText.trim() ? (0, _getNodeText2.getNodeText)(renderedText) : props["aria-label"];
  };
  const fireAnalytics = (0, _analytics.default)("Link", {
    text: analyticsText(),
    ...additionalAnalytics
  });
  const DynamicTag = href ? Styled.Anchor : Styled.Button;
  const isTanstackLink = href && router && (props === null || props === void 0 ? void 0 : props.target) !== "_blank" && !href.includes("tel:") && !disableRouter;
  const isOpinionatedExternalUrl = checkIsOpinionatedUrl(href);
  const relValue = rel || (isOpinionatedExternalUrl ? "nofollow" : undefined);
  const {
    REACT_APP_USE_THIRD_PARTY_INTERSTITIAL = true
  } = (0, _config.useConfig)();
  const handleOnClick = function (e) {
    const shouldTriggerInterstitial = (isExternal !== null && isExternal !== void 0 ? isExternal : isOpinionatedExternalUrl) && document.querySelector("#third-party-interstitial") !== null && REACT_APP_USE_THIRD_PARTY_INTERSTITIAL;
    fireAnalytics("click");
    if (shouldTriggerInterstitial) {
      e.preventDefault();
      show({
        href,
        target: props === null || props === void 0 ? void 0 : props.target
      });
    }
    if (typeof onClick === "function") {
      onClick(e);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicTag, {
    href: href,
    ...(!href && {
      type: "button"
    }),
    as: isTanstackLink ? VCRLink : undefined,
    onClick: handleOnClick,
    rel: relValue,
    "aria-label": props["aria-label"] || (0, _getNodeText2.getNodeText)(renderedText),
    ...props,
    "data-testid": "Link",
    children: renderedText
  });
};
var _default = exports.default = (0, _analytics.withAnalytics)(Link)({});